export default __webpack_public_path__ + "static/media/BlindOn.9faff322.svg";